import { render, staticRenderFns } from "./CourierPickupsManagement.vue?vue&type=template&id=2c53e782&scoped=true&"
import script from "./CourierPickupsManagement.vue?vue&type=script&lang=ts&"
export * from "./CourierPickupsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./CourierPickupsManagement.vue?vue&type=style&index=0&id=2c53e782&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53e782",
  null
  
)

export default component.exports